import { render, staticRenderFns } from "./training-pro-top.vue?vue&type=template&id=6469792c&scoped=true&"
import script from "./training-pro-top.vue?vue&type=script&lang=js&"
export * from "./training-pro-top.vue?vue&type=script&lang=js&"
import style0 from "./training-pro-top.vue?vue&type=style&index=0&id=6469792c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6469792c",
  null
  
)

export default component.exports